export default "__VITE_ASSET__B1TR66RJ__"